import React from "react";
import DoctorFormPage from "../components/doctors/DoctorFormPage";

const DoctorEdit = () => <DoctorFormPage mode="edit" />;

export default DoctorEdit;
